var render = function () {
  var _vm$estimate$document;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "dense": "",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.number'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.number,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "number", $$v);
      },
      expression: "estimate.number"
    }
  })], 1), _vm.canReadRepairEstimate ? _c('v-col', {
    staticClass: "d-flex justify-end align-start"
  }, [_c('div', [_c('m-icon-button', {
    attrs: {
      "icon": "mdi-open-in-new",
      "outlined": ""
    },
    on: {
      "click": function click() {
        return _vm.goToDetail();
      }
    }
  })], 1)]) : _vm._e()], 1), _c('v-row', {
    staticClass: "mb-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('requested'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.timestamp.createdReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate.timestamp, "createdReadable", $$v);
      },
      expression: "estimate.timestamp.createdReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('responded'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.respondedDate,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "respondedDate", $$v);
      },
      expression: "estimate.respondedDate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_vm.canReadAppraisal ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.date'),
      "readonly": "",
      "type": "date",
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "dateFormable", $$v);
      },
      expression: "estimate.dateFormable"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.status'),
      "chips": "",
      "readonly": "",
      "small-chips": "",
      "append-icon": '',
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.status,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "status", $$v);
      },
      expression: "estimate.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-text-field', {
    attrs: {
      "value": _vm.estimate.totalNet.toLocaleString('de-DE', {
        style: 'currency',
        currency: _vm.estimate.currency
      }),
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.total'),
      "hide-details": ""
    }
  })], 1)], 1)], 1), _vm.estimate.seller ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "mb-2 grey--text text--darken-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.seller")) + " ")]), _c('invoice-party-sheet', {
    attrs: {
      "invoice-party": _vm.estimate.seller,
      "color": "white"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.estimate.document ? [_vm.estimate.document] : [],
      "item-text": "name",
      "label": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.documentId'),
      "readonly": "",
      "chips": "",
      "small-chips": "",
      "append-icon": '',
      "hide-details": ""
    },
    model: {
      value: _vm.estimate.document,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "document", $$v);
      },
      expression: "estimate.document"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_vm.canUpdateRepairEstimate ? _c('select-assignees', {
    attrs: {
      "css": "width: 100%",
      "partnerId": _vm.estimate.partnerId,
      "outlined": false,
      "dense": false,
      "solo": false
    },
    on: {
      "input": _vm.onAssigneesUpdate,
      "added": _vm.onAssigneesAdded,
      "removed": _vm.onAssigneesRemoved
    },
    model: {
      value: _vm.estimate.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.estimate, "assignees", $$v);
      },
      expression: "estimate.assignees"
    }
  }) : _vm._e()], 1)], 1), _c('v-divider'), _c('m-expansion', {
    staticClass: "mb-1",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.positions", {
          count: _vm.estimate.lineItems.length
        })))];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showPositions,
      callback: function callback($$v) {
        _vm.showPositions = $$v;
      },
      expression: "showPositions"
    }
  }, [_c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": "grey lighten-4 mb-2"
    }
  }, [_c('line-items-form', {
    attrs: {
      "value": _vm.estimate,
      "showQuantity": "",
      "readonly": ""
    }
  })], 1)], 1), _c('v-divider'), _c('m-expansion', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.documentId")) + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showDocument,
      callback: function callback($$v) {
        _vm.showDocument = $$v;
      },
      expression: "showDocument"
    }
  }, [_vm.estimate && _vm.estimate.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : (_vm$estimate$document = _vm.estimate.document) !== null && _vm$estimate$document !== void 0 && _vm$estimate$document.url ? _c('iframe', {
    attrs: {
      "src": _vm.estimate.document.url,
      "width": "100%",
      "height": "800px"
    }
  }) : _c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.noDocumentText'),
      "color": "transparent"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }